import { CurrentUserFragment, UserRolePermission } from "../../../graphql";
import useFeatureFlag from "../../../graphql/hooks/useFeatureFlag";

const useUserCanAccessCoaching = (
  currentUser: CurrentUserFragment
): boolean => {
  const coachingEnabled = useFeatureFlag("coaching:v1");
  const userPermitted = currentUser.userRole?.permissions?.includes(
    UserRolePermission.EditAiTaskConfiguration
  );
  const notAnthropic =
    currentUser.organization.id !== "af391105-8a03-4dc7-aa42-4f1a422eb91f";
  return !!(coachingEnabled && userPermitted && notAnthropic);
};

export default useUserCanAccessCoaching;
